import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';

const StackItem = ({
  text,
  fields,
  added,
  edited,
  rotated,
  deleted,
  additionalButton,
  onClick,
  onDelete,
  onEdit,
  dragHandleProps,
  additionalElement,
}) => {
  let className = 'stack-item';

  let description = null;

  if (deleted) description = <span className="red">Deleted</span>;
  else if (rotated) description = <span className="blue">Rotated</span>;
  else if (added) description = <span className="green">Added</span>;
  else if (edited) description = <span className="blue">Edited</span>;

  return (
    <div className={className} onClick={onClick}>
      <div className="header">
        <div className="icons">
          {dragHandleProps ? (
            <div {...dragHandleProps} style={{ width: '20px', height: '20px' }}>
              <Icon src="grip-dots-vertical" height="20px" className="dragHandle" />
            </div>
          ) : null}
          {additionalButton}
          {!!onDelete && <Icon src="trash" showTooltip={true} onClick={onDelete} />}
          {!!onEdit && <Icon src="pencil" showTooltip={true} onClick={onEdit} />}
        </div>
        <span>{text}</span>
        <div className="content">{fields}</div>
        {description}
        {additionalElement}
      </div>
    </div>
  );
};

StackItem.propTypes = {
  text: PropTypes.string.isRequired,
  added: PropTypes.bool,
  rotated: PropTypes.bool,
  edited: PropTypes.bool,
  fields: PropTypes.array,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  additionalButton: PropTypes.element,
  additionalElement: PropTypes.element,
};

export default StackItem;
